import { Component, OnInit, Inject } from '@angular/core';
import { PageableListService } from '@app/common/services/pageable.list.service';
import { ListModel } from '@app/common/models/list.model';
import { PageableList } from '@app/models/pageable.list';
import { User } from '@app/models/user';
import { UserEditComponent } from '@app/common/components/user-edit/user-edit.component';
import { DialogService } from '@app/common/services/dialog.service';
import { HelpService } from '@app/common/services/help.service';
import { RESTANGULAR_SETTINGS } from '@app/common/services/restangular-settings.service';
import { RESTANGULAR_CONFIGURATION } from '@app/common/services/restangular-configuration.service';
import { APP_BRAND, APPLICATIONS } from '@app/common/services/config.service';
import { ProjectSubjectNamePipe } from '@app/ps/pipes/project-subject-name.pipe';
import {BrandService} from "@app/common/services/brand.service";

@Component({
  selector: 'user-list',
  templateUrl: './user-list.component.html',
})
export class UserListComponent implements OnInit {
  list: ListModel<User>;
  pageableList: PageableList;

  selectModules = [
    {name: this.applications.sy.title, id: this.applications.sy.name},
    {name: this.applications.di.title, id: this.applications.di.name},
    {name: this.applications.pk.title, id: this.applications.pk.name},
    {name: this.applications.dashboard.title, id: this.applications.dashboard.name},
    {name: this.applications.vfze.title, id: this.applications.vfze.name},
    {name: this.applications.sv.title, id: this.applications.sv.name},
    {name: this.applications.doss.title, id: this.applications.doss.name},
    {name: this.applications.psm.title, id: this.applications.psm.name},
    {name: 'Nic', id: ''},
  ];
  helpIds = HelpService.HELP_IDS;

  constructor(
    @Inject(APP_BRAND) public APP_BRAND: any,
    @Inject(APPLICATIONS) private applications: any,
    @Inject(RESTANGULAR_SETTINGS) private settingsRestangular: any,
    @Inject(RESTANGULAR_CONFIGURATION) public configurationRestangular: any,
    private pageableListService: PageableListService,
    private dialogService: DialogService,
    public projectSubjectNamePipe: ProjectSubjectNamePipe,
    private brandService: BrandService,
  ) {
    this.uiOnParamsChanged = this.uiOnParamsChanged.bind(this);
    this.onUsersSync = this.onUsersSync.bind(this);
    this.onCreate = this.onCreate.bind(this);
  }

  ngOnInit() {
    const allowed = [];
    if (this.brandService.isVisible('settings.modules.psm')) {
      allowed.push('PSM');
    }
    if (this.brandService.isVisible('settings.modules.dimap')) {
      allowed.push('DI');
    }
    if (this.brandService.isVisible('settings.modules.ps')) {
      allowed.push('SY');
    }
    if (this.brandService.isVisible('settings.modules.pk')) {
      allowed.push('PRO');
    }
    if (this.brandService.isVisible('settings.modules.vfze')) {
      allowed.push('VFZE');
    }
    if (this.brandService.isVisible('settings.modules.doss')) {
      allowed.push('DOSS');
    }
    if (this.brandService.isVisible('settings.modules.sv')) {
      allowed.push('VZORY');
    }
    if (this.brandService.isVisible('settings.modules.dash')) {
      allowed.push('DASH');
    }
    this.selectModules =  this.selectModules.filter(m => !m.id || allowed.includes(m.id));
    this.initializeList();
  }

  uiOnParamsChanged(changedParams, transition) {
    this.pageableList && this.pageableList.uiOnParamsChanged(changedParams, transition);
  }

  onUsersSync() {
    return this.settingsRestangular.one(`users/broadcast-users-update`).post().toPromise();
  }

  onCreate() {
    const dialog = this.dialogService.open(UserEditComponent, { data: {} });
    const sub = dialog.afterClosed.subscribe((res: User) => {
      if (res) {
        this.pageableList.fetchResults();
      }
      sub.unsubscribe();
    });
  }

  private initializeList() {
    this.pageableList = this.pageableListService.get(
      'users/list',
      this.getDefaultFilter(),
      'settingsUsersFilter',
    );

    this.list = this.pageableList.list;
    this.pageableList.load();
  }

  private getDefaultFilter() {
    return {
      filters: {
        searchText: {
          values: [{id: ''}]
        },
        applications: {},
        companyTextId: {values:[]},
        companyId: {},
        hasCompany: {values:[]},
      }
    };
  }

  public onCustomerChanged(event) {
    this.list.filter.filters.companyTextId.values = event.newValue.map(v => {
      return {
        id: v.idText,
      };
    });
  }
}
